export const PrintLabelErrorMessages = {
    ERROR_WHILE_GENERATING_PDF: "Error occurred while generating PDF sheet",
    ERROR_WHILE_FETCHING_LABEL: "Error occurred while fetching label sheet",
    DEFAULT: "Print Server Error"
}


// WEBPACK FOOTER //
// ./src/components/labelSheet/constants/PrintLabelErrorMessages.js